export default __webpack_public_path__ + "static/media/payment-screen3-min.b4bbf0c8.jpg";